const state = {
    downloadDocument: null,
    loading: false
};

export default state;